const rooMutations = {
  SET_CURRENT_CATEGORY_MUTATION: (state, payload) => {
    state.currentCategory = payload.currentCategory;
  },
};

export default rooMutations;
